/* eslint  no-alert: 0 */
/* eslint no-mixed-operators:0 */

import React from 'react';
import $ from 'jquery';

import { BLOCK_TYPE } from '../utilities/CONSTANTS';
import { getBlockPosition } from '../utilities/selectionUtilities';

const CONTROLS = [
    { label: 'Bullet', style: BLOCK_TYPE.UNORDERED_LIST, icon: 'list-unordered' },
    { label: 'List', style: BLOCK_TYPE.ORDERED_LIST, icon: 'list-ordered' },
    { label: 'Line', style: BLOCK_TYPE.HR, icon: 'hr' },
    { label: 'Code', style: BLOCK_TYPE.CODE, icon: 'code' },
    { label: 'Callout', style: BLOCK_TYPE.CALLOUT, icon: 'callout' },
];

const TABLE = { label: 'Table', style: BLOCK_TYPE.TABLE, icon: 'table' };

const DEFAULT_STATE = {
    open: false,
    blockPosition: {
        top: 0,
        left: 0,
    },
};

const pickFile = (e) => {
    e.preventDefault();
    document.getElementById('file-input').click();
};

const ImageButton = () => (
    <div className="control-button" onMouseDown={pickFile}>
        <span className="icon icon-image" />
        Image
    </div>
);

const FileButton = () => (
    <div className="control-button" onMouseDown={pickFile}>
        <span className="icon icon-file" />
        File
    </div>
);

const EmbedButton = ({ toggleEmbedlyDialog }) => {
    // Handle weird click behavior from #8100
    const embedOnMouseDown = (e) => {
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();
    };

    const embedOnClick = (e) => {
        setTimeout(() => toggleEmbedlyDialog(true), 1);
    };

    return (
        <div
            className="control-button"
            onMouseDown={embedOnMouseDown}
            onClick={embedOnClick}
        >

            <span className="icon icon-embed" />
            Embed
        </div>
    );
};

class InsertControls extends React.Component {
    timeoutId = null;

    constructor(props) {
        super(props);
        this.state = DEFAULT_STATE;
        this.$body = $('body');
    }

    componentDidMount() {
        this.setBlockPosition();
    }

    componentDidUpdate() {
        const { open } = this.state;
        this.setBlockPosition();

        if (open) {
            this.$body.off('click', this.closeControlsOnClick);
            this.$body.on('click', this.closeControlsOnClick);
        } else {
            this.$body.off('click', this.closeControlsOnClick);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutId);
        this.$body.off('click', this.closeControlsOnClick);
    }

    setBlockPosition = () => {
        const { editorState } = this.props;
        const { blockPosition } = this.state;

        this.timeoutId = setTimeout(() => {
            const newPos = getBlockPosition(editorState);
            if (newPos != null && (newPos.left !== blockPosition.left || newPos.top !== blockPosition.top)) {
                this.setState({ blockPosition: newPos });
            }
        });
    };

    closeControlsOnClick = (e) => {
        const $target = $(e.target);
        if (!$target.is('.insert-controls-container') && !$target.parents().is('.insert-controls-container')) {
            this.setState(DEFAULT_STATE);
        }
    };

    clickControl = (style, e) => {
        const { toggleBlockType } = this.props;
        e.preventDefault();
        toggleBlockType(style);
        this.setState(DEFAULT_STATE);
    };

    openControls = (e) => {
        const { open } = this.state;
        e.preventDefault();
        this.setState({
            open: !open,
        });
    };

    getPosition = () => {
        const { editorState } = this.props;
        const { blockPosition } = this.state;
        const containerNode = document.getElementById('post-editor-content');
        const containerNodeBounding = containerNode.getBoundingClientRect();
        const titleNode = document.getElementById('post-editor-title');
        const titleNodeBounding = titleNode.getBoundingClientRect();
        const { height: titleHeight } = titleNodeBounding;

        return ({
            left: -36,
            top: blockPosition.top - containerNodeBounding.y + titleHeight - 12,
        });
    };

    render() {
        const { config: { enableTables, enableEmbeds }, toggleEmbedlyDialog } = this.props;
        const { open, blockPosition } = this.state;

        const buttonClassName = open ? 'insert-button open' : 'insert-button';
        const controls = enableTables ? CONTROLS.concat(TABLE) : CONTROLS;

        if (blockPosition == null) {
            return null;
        }

        const position = this.getPosition();

        return (
            <div className="insert-controls-container" style={position}>
                <div className={buttonClassName} onMouseDown={this.openControls} aria-label="add block content">
                    <img height="12" width="12" src="/img/icons/insert-plus-icon.svg" />
                </div>
                {open && (
                    <div className="insert-controls">
                        { enableEmbeds && <EmbedButton toggleEmbedlyDialog={toggleEmbedlyDialog} />}
                        <ImageButton />
                        <FileButton />
                        {controls.map(control => (
                            <div
                                key={control.label}
                                id={`insert-${control.icon}`}
                                className="control-button"
                                onMouseDown={(e) => { this.clickControl(control.style, e); }}
                            >
                                <span className={`icon icon-${control.icon}`} />
                                {control.label}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

export default InsertControls;
